import { createSlice } from "@reduxjs/toolkit";
import { ICampusSafetyAlertSlice } from "../../../models/common/INavbar";

const initialCampusSafetyAlertDetails: ICampusSafetyAlertSlice = {
    safetyAlerts: undefined,
};

const safetyAlertSlice = createSlice({
    name: "SafetyAlertDetails",
    initialState: initialCampusSafetyAlertDetails,
    reducers: {
        setSafetyAlert: (state, action: { payload: any }) => {
            state.safetyAlerts = action.payload;
        },
    },
});

export const { setSafetyAlert } = safetyAlertSlice.actions;

const safetyAlertReducer = safetyAlertSlice.reducer;

export type safetyAlertState = ReturnType<typeof safetyAlertReducer>;

export default safetyAlertReducer;